import JSZip from 'jszip'

const DICOM_NAME = /\.(dcm|dicom)$/i

/**
 * Extrae instancias DICOM de un ZIP local como File[] listos para el visor.
 * @param {Blob|File|ArrayBuffer} zipSource
 * @returns {Promise<File[]>}
 */
export async function extractDicomFilesFromZip(zipSource) {
  if (!zipSource) return []

  const zip = await JSZip.loadAsync(zipSource)
  const names = Object.keys(zip.files || {})
  const dicomNamed = names.filter((n) => {
    const e = zip.files[n]
    return e && !e.dir && DICOM_NAME.test(n)
  })
  const fileNames =
    dicomNamed.length > 0
      ? dicomNamed
      : names.filter((n) => zip.files[n] && !zip.files[n].dir)

  const out = []
  for (let i = 0; i < fileNames.length; i++) {
    const name = fileNames[i]
    const entry = zip.files[name]
    if (!entry || entry.dir) continue
    const buffer = await entry.async('arraybuffer')
    if (!buffer || buffer.byteLength < 128) continue
    const base = name.split('/').pop() || `instance-${i + 1}.dcm`
    const fileName = /\.(dcm|dicom)$/i.test(base) ? base : `${base}.dcm`
    out.push(
      new File([buffer], fileName, {
        type: 'application/dicom',
        lastModified: Date.now(),
      })
    )
  }
  return out
}

export default extractDicomFilesFromZip
